import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import ChooseSection from '../../components/ChooseSection/ChooseSection';
import Header from '../../components/ChooseSection/Navbar/Header';
import Footer from "../../components/Footer/Footer";
import { Card } from "react-bootstrap";
import Blog1Img from "../../images/blog1-img.jpg";
import homeimg from "../../images/homeimg.jpg";
import Blog2Img from "../../images/blog2-img.jpg";
import Blog3Img from "../../images/blog3-img.jpg";
import logoImage from "../../images/logo.png";

const blogs = [
  {
    id: 1,
    img: [Blog1Img],
    title: "Smart Classrooms",
    description:
      "Our college has individual and well-equipped smart classroom for each department. The smart classroom helps to renovate the traditional education system into modernized one. It provides eminence education to students through better concept formation, concept elaboration, improvement in reading skills and academic attainment.",
  },
  {
    id: 2,
    img: [Blog2Img],
    title: "Laboratories",
    description:
      "Our College Provides modern and sophisticated teaching facilities that are constantly upgraded. Each department at the institute boasts of an array of highly advanced laboratories that are sufficiently equipped with the latest instruments and apparatus. The aim is to provide students a conceptual as well as practical understanding of the subject through hands-on training.",
  },
  {
    id: 3,
    img: [Blog3Img],
    title: "Sports",
    description:
      "Sport is an integral part of the curriculum. Various sports facility is provided to the students within the campus. The College is committed to create a balanced atmosphere of academic, cultural and sports activities for the overall personality development of its students. Talented students are honored with medals, trophies and certificates.",
  },
];

function Home() {
  return (
    <div className="home-page">
      <Header />

      <header className="h-80 min-vh-100 d-flex justify-content-center align-items-center text-light">
        <div className="container d-flex justify-content-center flex-column align-items-center ">
          <img src={logoImage} width="90" height="90" />
          <h2>Welcome To</h2>
          <h1 className="text-center fw-bold">
            Pandit Ram Kedar Ram Kishore Tripathi Mahavidyalaya
          </h1>

          <div className="d-flex flex-column flex-sm-row align-items-center">
            <Link to="/courses">
              <button
                type="button"
                className="btn btn-danger btn-lg mx-0 mx-sm-2 my-2 my-sm-0"
              >
                Our Courses
              </button>
            </Link>
            <Link to="/contact">
              <button
                type="button"
                className="btn btn-outline-light btn-lg mx-0 mx-sm-2 my-2 my-sm-0"
              >
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      </header>

      <div className="py-5">
        <ChooseSection />
      </div>

      <div
        className="py-2"
        style={{ backgroundColor: "rgba(192, 192, 193, 0.645)" }}
      >
        <div className="container">
          <div className="row d-flex align-items-center justify-content-around">
            <div className="col-lg-6">
              <h2 className="text-capitalize">Admission for The A.Y. 2025-26
              </h2>
              <p>
                Registration Date: 01-05-2025 to 31-07-2025 (URN Generation Date)

              </p>
              <h5>Admission Open
              </h5>
              <p>
                <table >
                  <tr>
                    <th width="20%">Course</th>
                    <th>Subject Available</th>
                  </tr>
                  <tr>
                    <td> B.A. </td>
                    <td >HINDI, ENGLISH, SANSKRIT, HOME SCIENCE, GEOGRAPHY, POLITICAL SCIENCE, SOCIOLOGY, PHYSICAL EDUCATION, EDUCATION,, MILITARY SCIENCE, ARTS & DRAWING, MUSIC, PSYCHOLOGY, URDU
                    </td>
                  </tr>
                  <tr>
                    <td> B.Sc.  </td>
                    <td>BOTANY, CHEMISTRY, ZOOLOGY, PHYSICS, MATHEMATICS </td>
                  </tr>
                  <tr>
                    <td>  M.A.  </td>
                    <td>HINDI, HOME SCIENCE, SOCIOLOGY, EDUCATION </td>
                  </tr>

                </table>
              </p>
              <p>Admission Helpline No : 9450766421, 8317081760, 8953019132, 7268883960
              </p>
              <p>Technical Helpline Number : 6394230457, 9721340339</p>
              <Link to="/admission">
                <button
                  type="button"
                  className="btn btn-danger btn-sm mx-0 mx-sm-2 my-2 my-sm-0"
                >
                  Apply Online
                </button>
              </Link>
              <a href="./img/prospectus.pdf"
                target="_blank"
                type="button"
                className="btn btn-danger btn-sm mx-2 mx-sm-2 my-2 my-sm-0"
              >
                Prospectus
              </a>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <img
                src="./img/course.jpg"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="py-5">
            <FaqAccordion />
        </div> */}
      <br />
      <div className="blog-section text-light py-5 fl">
        <div className="container d-flex flex-column align-items-center">
          <h2 className="text-center text-capitalize mb-5">Our Facilities</h2>
          <div className="row g-4">
            {blogs.map((blog) => (
              <div key={blog.id} className="col-md-6 col-lg-4">
                <Link to="/" className="text-decoration-none">
                  <Card className="h-100 shadow ">
                    <Card.Img variant="top" src={blog.img} />
                    <Card.Body
                      className="p-md-3"
                      style={{ textAlign: "justify" }}
                    >
                      <Card.Title>{blog.title}</Card.Title>
                      <Card.Text>{blog.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Link>
              </div>
            ))}
          </div>
          <Link to="/">
            <a className="btn btn-danger btn-lg mt-5" href="#" role="button">
              View More
            </a>
            {/* <button type='button' className='btn btn-danger btn-lg mt-5'>View More</button> */}
          </Link>
        </div>
      </div>
      <br />

      <div
        className="text-dark py-3 "
        style={{ backgroundColor: "rgba(192, 192, 193, 0.645)" }}
      >
        <div className="container d-flex flex-column align-items-center">
          <div className="row g-4 justify-content-between">
            <div className="col-md-6 col-lg-4">
              <Card className=" shadow ">
                <Card.Img
                  className="h-100 w-100 img-card"
                  variant="top"
                  src="./img/foundermanager.png"
                />
                <Card.Body className="p-md-3" style={{ textAlign: "justify" }}>
                  <Card.Title style={{ fontSize: "16px", textAlign: "center" }}>
                    Dr. Om Prakash Tripathi
                    <br />
                    Manager
                  </Card.Title>
                  <Card.Text style={{ fontSize: "12px", textAlign: "center" }}>
                    PTRKT College, Sultanpur
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-6 col-lg-4">
              <Card className=" shadow c2">
                <Card.Img
                  className="h-100 w-100 img-card"
                  variant="top"
                  src="./img/principal.png"
                />
                <Card.Body className="p-md-3" style={{ textAlign: "justify" }}>
                  <Card.Title style={{ fontSize: "16px", textAlign: "center" }}>
                    Dr. Indra Mani Shukla
                    <br />
                    <br />
                    Principal
                  </Card.Title>

                  <Card.Text style={{ fontSize: "12px", textAlign: "center" }}>
                    PTRKT College, Sultanpur
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
            {/* ))} */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;